<ion-modal [canDismiss]="canDismiss" (didDismiss)="this.modalClosed()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="back()" aria-label="Back Button"><ion-icon
              name="arrow-back-outline"></ion-icon></ion-button>
        </ion-buttons>

        <ion-title>My Account</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-list *ngIf="state === AccountModalState.Initial">
        <ion-item>
          <ion-button (click)="goHome()" aria-label="Home Button">Go Home</ion-button>
        </ion-item>
        <ion-item>
          <ion-button (click)="logout()" aria-label="Logout Button">Logout</ion-button>
        </ion-item>
        <ion-item>
          <ion-button (click)="deleteAccount()" aria-label="Delete Account Button">Delete Account</ion-button>
        </ion-item>
        <ion-item *ngIf="account.session?.authMethod === AuthMethodType.Local">
          <ion-button (click)="state = AccountModalState.ChangePassword" aria-label="Change Password Button"> Change my
            Password </ion-button>
        </ion-item>
        <ion-item>
          <ion-button (click)="settings()" aria-label="Settings Button">App Info</ion-button>
        </ion-item>
      </ion-list>

      <!-- Change Password Form -->
      <form *ngIf="state === AccountModalState.ChangePassword" [formGroup]="changePasswordForm"
        (ngSubmit)="submitChangePassword()">

        <!-- Old Password -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <ion-input type="password" placeholder="Old Password" formControlName="old_password" password
              autocomplete="current-password" [clearOnEdit]="false" fill="solid" mode="md"><ion-input-password-toggle
                slot="end"></ion-input-password-toggle></ion-input>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <div class="error-container">
              <ng-container *ngFor="let validation of validations.password">
                <div class="error-message" *ngIf="
                              changePasswordForm.get('old_password')!.hasError(validation.type) &&
                              (changePasswordForm.get('old_password')!.dirty || changePasswordForm.get('old_password')!.touched)
                            ">
                  <ion-icon name="information-circle-outline"></ion-icon>
                  <span>{{ validation.message }}</span>
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <!-- New Password -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <ion-input type="password" placeholder="New Password" formControlName="password" password
              autocomplete="new-password" fill="solid" mode="md"><ion-input-password-toggle
                slot="end"></ion-input-password-toggle></ion-input>
          </ion-col>
        </ion-row>
        <!-- Password validation not working correctly - commenting out for now.
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <div class="error-container">
              <ng-container *ngFor="let validation of validations.password">
                <div class="error-message" *ngIf="
                              changePasswordForm.get('password')!.hasError(validation.type) &&
                              (changePasswordForm.get('password')!.dirty || changePasswordForm.get('password')!.touched)
                            ">
                  <ion-icon name="information-circle-outline"></ion-icon>
                  <span>{{ validation.message }}</span>
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row> -->

        <!-- New Password Confirm -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <ion-input type="password" placeholder="Confirm Password" formControlName="confirm_password" password
              autocomplete="new-password" fill="solid" mode="md"><ion-input-password-toggle
                slot="end"></ion-input-password-toggle></ion-input>
          </ion-col>
        </ion-row>
        <!-- Password validation not working correctly - commenting out for now.
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <div class="error-container">
              <ng-container *ngFor="let validation of validations.confirm_password">
                <div class="error-message" *ngIf="
                              changePasswordForm.get('confirm_password')!.hasError(validation.type) &&
                              !changePasswordForm.get('password')!.hasError(validation.type) &&
                              (changePasswordForm.get('confirm_password')!.dirty ||
                                changePasswordForm.get('confirm_password')!.touched)
                            ">
                  <ion-icon name="information-circle-outline"></ion-icon>
                  <span>{{ validation.message }}</span>
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row> -->

        <!-- Submit Change Password Button -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" sizeMd="8">
            <ion-button class="onco-primary-button" type="submit" expand="block" fill="outline"
              aria-label="Change Password Button" [disabled]="signinDisabled || !changePasswordForm.valid">Change
              Password</ion-button>
          </ion-col>
        </ion-row>
      </form>

    </ion-content>
  </ng-template>
</ion-modal>